$(document).ready(function () {
	(function ($) {
		const backdropClass = 'modal-backdrop';
		const modalClass = 'modal';
		const bigModalClass = 'modal--lg';
		const smModalClass = 'modal--sm';
		const backdropMarkup = '<div class="' + backdropClass + '"></div>';
		const containerMarkup = '<div class="' + modalClass + '"></div>';
		const bigContainerMarkup = '<div class="' + modalClass + ' ' + bigModalClass + '"></div>';
		const smContainerMarkup = '<div class="' + modalClass + ' ' + smModalClass + '"></div>';
		const $backdropContainer = $('html');
		const mainContent = $('.content__main');

		// append the container into the DOM
		$backdropContainer
			.append(containerMarkup)
			.append(bigContainerMarkup)
			.append(smContainerMarkup);

		$.fn.modal = function (action) {
			const el = !this.hasClass('modal') ? this.find('.modal') : this;
			if (!el) {
				return;
			}

			if (action === 'show') {

				el.addClass('visible');
				$backdropContainer.append(backdropMarkup);

				mainContent.addClass('disable-scroll');
				var modalTop = $(window).width() <= 575 ? 0 : 5;		
				el.animate({ opacity: 1, top: (modalTop + '%') }, { duration: 300 }, () => {
					el.registerModalListeners();
				});
			} else if (action === 'hide') {

				mainContent.removeClass('disable-scroll');
				el.animate({ opacity: 0, top: 0 }, {
					duration: 300, complete: () => {
						el.removeClass('visible');
						$('.' + backdropClass).remove();
					}
				});

				el.trigger('modal:closed');
				el.off();
			}
			return this;
		};

		$.fn.modal2 = $.fn.modal;

		$.fn.registerModalListeners = function () {
			$('[action="close-modal"]').click(() => {
				this.modal2('hide');
			});

			$(document).on('keyup', (e) => {
				if (e.key === 'Escape') {
					this.modal('hide');
					$(document).off('keyup');
				}
			});

			// Listen to clicks on the modal and close any open select2 dialogs
			$('.modal').click(function (e) {
				if (!$(e.target).parents('.select2').length) {
					$('select').closeSelect2();
				}
			});

			return this;
		};


		$('[data-action="open-modal"]').click(function () {
			const target = $(this).data('target');
			$(target).modal('show');
		});

		$(window).resize(() => {
			$('select').closeSelect2();
		});


		$.fn.closeSelect2 = function () {
			$(this).each(function (i, obj) {
				if ($(obj).data('select2')) {
					$(obj).select2().select2('close');
				}
			});
		};

		$.fn.showLoader = function () {
			this.oldHtml = $(this).html();
			$(this).html('<div class="loader"></div>');
		};

		$.fn.hideLoader = function () {
			$(this).html(this.oldHtml);
		};

		$.fn.btnProgressStart = function () {
			this.oldHtml = $(this).html();

			$(this)
				.addClass('btn--saving')
				.attr('disabled', 'true')
				.html('<span class="osci osci-refresh"></span>');
		};

		$.fn.btnProgressEnd = function () {
			$(this)
				.removeClass('btn--saving')
				.removeAttr('disabled')
				.html(this.oldHtml);
		};

		$.fn.hover = function () {
			$(this).on('mouseenter', function () {
				var pos = $(this).data('hover-pos');
				var msg = $(this).data('hover');
				var position = $(this).offset();
				var left = pos === 'left' ? position.left - $(this).outerWidth() - 60 : position.left + $(this).outerWidth() + 10;
				var top = position.top + $(this).outerHeight() / 2 - 20;


				$('body').append(`<div class="hover" style="top: ${top}px; left: ${left}px">${msg}</div>`);
			});

			$(this).on('mouseleave click', function () {
				$('.hover').remove();
			});
		};

		$('.sub-nav').each(function () {
			const target = $(this).data('target');
			if (target) {

				$(target).find('[data-section]').hide();
				const activeItem = $(this).children('.active');

				if (activeItem) {
					$(target).find('[data-section="' + activeItem.data('section') + '"]').show();
				}

				$('.sub-nav__item').click(function () {
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
					const subtarget = $(this).data('section');
					if (subtarget) {
						$(target).find('[data-section]').hide();
						$('[data-section="' + subtarget + '"]').show();
					}
				});
			}
		});

		function skip(el) {
			$(el).trigger('blur');
			var tar = $(el).data('target');
			$(tar).find('button, a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])').first().focus();
        }

		$('.skip-to-main-link').click(() => { return skip(this); });
		$('.skip-to-main-link').keyup(function (e){
			if (e.which == 13 || e.which == 32) {
				return skip(this);
			}
		});

	}(jQuery));
});
